import * as React from 'react';
import { PageProps } from 'gatsby';
import '../styles/base.css';
import Visual from '../components/organisms/Visual';
import Header from '../components/atoms/Header';
import Menu from '../components/atoms/Menu';
import HomeMainLeft from '../components/molecules/HomeMainLeft';
import HomeMainRight from '../components/molecules/HomeMainRight';
import Footer from '../components/molecules/Footer';
const BlogIndex: React.FC<PageProps<any>> = () => {
  return (
    <>
      <Header />
      <Menu />
      <main className="main">
        {/* メインビジュアル */}
        <Visual />
        {/* メインビジュアル END */}

        <div className="clearfix">
          <HomeMainLeft />
          <HomeMainRight />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default BlogIndex;
